import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfTab from '@elem/ui/ef-tab';
import EfTitle from '@elem/ui/ef-title';
import EfWhatInBox from '@elem/ui/ef-what-in-box';
import { useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.WhatInBox');

    const listA1 = [
        {
            title: t('a_item1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736925516607/1.png',
        },
        {
            title: t('a_item2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png',
        },
        {
            title: t('a_item3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png',
        },
        {
            title: t('a_item4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580660907/1.png',
        },
    ];
    const listA2 = [
        {
            title: t('b_item1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736925847268/r3p1.png',
        },
        {
            title: t('b_item2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png',
        },
        {
            title: t('b_item3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png',
        },
        {
            title: t('b_item4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580369866/usb.png',
        },
        {
            title: t('b_item5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580687382/2.png',
        },
    ];
    const listA3 = [
        {
            title: t('c_item1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736926163840/r3m1.png',
        },
        {
            title: t('c_item2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png',
        },
        {
            title: t('c_item3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png',
        },
        {
            title: t('c_item4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580369866/usb.png',
        },
        {
            title: t('c_item5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580693542/3.png',
        },
    ];

    const listA4 = [
        {
            title: t('d_item1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736926593158/r3mp.png',
        },
        {
            title: t('d_item2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png',
        },
        {
            title: t('d_item3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png',
        },
        {
            title: t('d_item4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580369866/usb.png',
        },
        {
            title: t('d_item5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580693542/3.png',
        },
    ];
    const [listA, setListA] = useState(listA1);
    const [items] = useState([
        {
            type: 'listA1',
            title: t('a_tab'),
        },
        {
            type: 'listA2',
            title: t('b_tab'),
        },
        {
            type: 'listA3',
            title: t('c_tab'),
        },
        {
            type: 'listA4',
            title: t('d_tab'),
        },
    ]);
    const [activeItem, setActiveItem] = useState(items[0]);
    const onChange = (item: any) => {
        const type = item.type;
        if (type === 'listA1') {
            setListA(listA1);
        } else if (type === 'listA2') {
            setListA(listA2);
        } else if (type === 'listA3') {
            setListA(listA3);
        } else if (type === 'listA4') {
            setListA(listA4);
        }
        setActiveItem(item);
    };
    return (
        <div className={`${styles.TheComp} WhatInBox-type-${activeItem.type}`}>
            <EfSpec />
            <EfTitle hasAnimation={false}>{t('title')}</EfTitle>
            <EfWhatInBox list={listA} />
            <div className="WhatInBox-type-container">
                <div className='WhatInBox-type-content'>
                <EfTab items={items} onChange={onChange} />
                </div>
            </div>

            <EfSpec />
        </div>
    );
}
